// src/components/PlaceholderComponent.js (or similar path)
import React from 'react';

const PlaceholderComponent = ({ pageName }) => (
  <div style={{ padding: '20px', border: '1px dashed #ccc', borderRadius: '8px', backgroundColor: '#f9f9f9', marginTop: '20px' }}>
    <h2>{pageName} Page</h2>
    <p>Content for {pageName} will be displayed here.</p>
    <p>You currently have files for Profile, Security, and RoleManager (which is part of Permissions).</p>
  </div>
);

export default PlaceholderComponent;